import detectPassiveEvents from 'detect-passive-events';
import { easeOutCubic } from '@/common/animate';

// window.addEventListener("wheel", stopScrolling, detectPassiveEvents.hasSupport ? {passive: true} : false);
window.addEventListener('touchstart', stopScrolling, detectPassiveEvents.hasSupport ? { passive: true } : false);

let rafId;
let startValue;
let endValue;
let currentTime;
let startTime;
let direction;

export default function scrollTop(_target = 0) {
    if (rafId) {
        stopScrolling();
        rafId = null;
        return true;
    }
    let offset = window.pageYOffset;
    let target = _target < 0 ? 0 : _target;
    if (offset < 10 || target === offset) {
        return false;
    }
    startValue = offset;
    endValue = target;
    direction = offset - target > 0 ? 'up' : 'down';
    currentTime = 0;
    startTime = null;
    rafId = window.requestAnimationFrame(scrollStep);
    return true;
}

function stopScrolling() {
    window.cancelAnimationFrame(rafId);
}

function scrollStep(timestamp) {
    if (!startTime) {
        startTime = timestamp;
    }

    currentTime = timestamp - startTime;

    let position = easeOutCubic(currentTime, startValue, endValue, 250);

    if (
        (direction === 'up' && window.pageYOffset <= endValue) ||
        (direction === 'down' && window.pageYOffset >= endValue)
    ) {
        stopScrolling();
        rafId = null;
    } else {
        window.scrollTo(0, position);
        rafId = window.requestAnimationFrame(scrollStep);
    }
}
